module.exports = __webpack_public_path__ + "static/124-80e8e2639f34fa8252bc5f498815cb7b.jpg";